export const newBarcelona600 = [
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/9d562e872a09baf6729805b5f8a9f1b70a7140caaccbc9e1206a0121.jpg",
    type: "Room",
    available: "From 7 May",
    title: "Room for rent in 4-bedroom apartment in Barcelona",
    rent: "240 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/602190?move-in=2022-05-31",
    permonth: "/month",
    id: 1,
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/ea5976ab106bf118d9344eeefb5f1ae745d76a81f4a174bb4e272956.jpg",
    type: "Room",
    available: "From 8 May",
    title: "Room for rent in 4-bedroom apartment in Barcelona",
    rent: "290 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/602189?move-in=2022-05-31",
    permonth: "/month",
    id: 2,
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/b235fb40fb98a557b40a2a6ab50e0f082004b7399a30cad0e3e7a790.jpg",
    type: "Room",
    available: "From 28 May",
    title: "Snug room for rent in 6-bedroom apartment, El Raval",
    rent: "310 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/302457?move-in=2022-05-31",
    permonth: "/month",
    id: 3,
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/bc5956e353e681bee37688a1e9776730cea83d36ec71e4c717aad8f4.jpg",
    type: "Room",
    available: "From 9 May",
    title: "Room in 4-bedroom apartment for rent in Barcelona",
    rent: "320 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/602184?move-in=2022-05-31",
    permonth: "/month",
    id: 4,
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/6a1039b785b7f2443f59b190a9555eefd678a7d1fa31b0b8e8c29b28.jpg",
    type: "Room",
    available: "From 29 March",
    title: "Room for rent in 3-bedroom apartment in Barcelona",
    rent: "340 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/643728?move-in=2022-05-31",
    permonth: "/month",
    id: 5,
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/c2342cacd5064c223e6f062aff8691778bb45bf1063f155b749b31be.jpg",
    type: "Room",
    available: "From 7 May",
    title: "Room for rent in 4-bedroom apartment in Sants, Barcelona",
    rent: "345 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/247645?move-in=2022-05-31",
    permonth: "/month",
    id: 6,
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/d4590d4de9ad845ee8d915910414d8c3adeb37387ed15954cf0d8ca7.jpg",
    type: "Room",
    available: "From 26 April",
    title: "Room for rent in 1-bedroom apartment in Barcelona",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/579793?move-in=2022-05-31",
    permonth: "/month",
    id: 7,
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/4c15a14ccc29c41051c99cb926452a068caf3d22ca32dae2f968ef2a.jpg",
    type: "Room",
    available: "From 1 May",
    title: "Room for rent in 3-bedroom apartment in Barcelona",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/611234?move-in=2022-05-31",
    permonth: "/month",
    id: 8,
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/e80a5105dfe6cfbb5a9f4964090336990a48d6fad7b9aa3c490caa37.jpg",
    type: "Room",
    available: "From 31 May",
    title: "Rooms for rent in 3-bedroom apartment in Barcelona",
    rent: "350 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/569116?move-in=2022-05-31",
    permonth: "/month",
    id: 9,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 April",
    title: "Room for rent in 3-bedroom apartment in Sants, Barcelona",
    rent: "380 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/403024?move-in=2022-05-31",
    permonth: "/month",
    id: 10,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 6 May",
    title: "Room in shared apartment in Barcelona",
    rent: "385 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/598087?move-in=2022-05-31",
    permonth: "/month",
    id: 11,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 April",
    title: "room for rent in 3-bedroom apartment in Barcelona",
    rent: "390 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/295039?move-in=2022-05-31",
    permonth: "/month",
    id: 12,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 9 May",
    title: "Furnished room in 2-bedroom apartment in El Raval, Barcelona",
    rent: "390 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/89446?move-in=2022-05-31",
    permonth: "/month",
    id: 13,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 31 May",
    title: "Room to rent in 3-bedroom apartment L’Hospitalet, Barcelona",
    rent: "399 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/276516?move-in=2022-05-31",
    permonth: "/month",
    id: 14,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 27 April",
    title: "Colourful room in 4-bedroom apartment in Horta-Guinardo",
    rent: "400 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/231824?move-in=2022-05-31",
    permonth: "/month",
    id: 15,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 5 May",
    title: "Inviting room in 5-bedroom apartment in El Raval, Barcelona",
    rent: "400 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/129691?move-in=2022-05-31",
    permonth: "/month",
    id: 16,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 29 May",
    title: "Rooms for rent in 3-bedroom apartment in L'Hospitalet De Llo",
    rent: "400 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/611893?move-in=2022-05-31",
    permonth: "/month",
    id: 17,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 30 May",
    title: "Room in 5-bedroom apartment in L'Hospitalet de Llobregat",
    rent: "400 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/359849?move-in=2022-05-31",
    permonth: "/month",
    id: 18,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 30 May",
    title: "Rooms for rent in 3-bedroom apartment in Barcelona",
    rent: "400 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/255903?move-in=2022-05-31",
    permonth: "/month",
    id: 19,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 31 May",
    title: "Room in 5-bedroom apartment in Horta-Guinardó, Barcelona",
    rent: "405 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/334046?move-in=2022-05-31",
    permonth: "/month",
    id: 20,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 9 April",
    title: "Comfortable room for rent in Poble Sec, Barcelona",
    rent: "420 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/341529?move-in=2022-05-31",
    permonth: "/month",
    id: 21,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 May",
    title: "Room for rent in 3-bedroom apartment in",
    rent: "420 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/349510?move-in=2022-05-31",
    permonth: "/month",
    id: 22,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 May",
    title: "Room for rent in 3-bedroom apartment",
    rent: "420 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/349509?move-in=2022-05-31",
    permonth: "/month",
    id: 23,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 3 May",
    title: "Room to rent in 3-bedroom apartment in Sant Martí",
    rent: "420 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/358361?move-in=2022-05-31",
    permonth: "/month",
    id: 24,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 14 May",
    title: "Cosy room for rent in apartment in L'Hospitalet de Llobregat",
    rent: "425 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/389596?move-in=2022-05-31",
    permonth: "/month",
    id: 25,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 20 May",
    title: "Cozy room in shared apartment in Eixample, Barcelona",
    rent: "426 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/96506?move-in=2022-05-31",
    permonth: "/month",
    id: 26,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 27 April",
    title: "Room in 4-bedroom apartment in L'Esquerra de l'Eixample",
    rent: "430 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/302438?move-in=2022-05-31",
    permonth: "/month",
    id: 27,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 29 April",
    title: "Rooms for rent in 2-bedroom apartment in Sarrià, Barcelona",
    rent: "439 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/406873?move-in=2022-05-31",
    permonth: "/month",
    id: 28,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 31 May",
    title: "Room for rent in 3-bedroom apartment in L'Hospitalet",
    rent: "449 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/415003?move-in=2022-05-31",
    permonth: "/month",
    id: 29,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 14 April",
    title: "Sweet room in apartment in Sarrià-Sant Gervasi, Barcelona",
    rent: "450 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/103976?move-in=2022-05-31",
    permonth: "/month",
    id: 30,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 16 April",
    title: "Room for rent in 4-bedroom apartment Sant Martí, Barcelona",
    rent: "450 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/346464?move-in=2022-05-31",
    permonth: "/month",
    id: 31,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 19 April",
    title: "Cosy room in 4-bedroom apartment in Poblenou, Barcelona",
    rent: "450 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/229997?move-in=2022-05-31",
    permonth: "/month",
    id: 32,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 21 April",
    title: "Furnished room in 4-bedroom apartment in Poblenou, Barcelona",
    rent: "450 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/229996?move-in=2022-05-31",
    permonth: "/month",
    id: 33,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 4 May",
    title: "Bedroom 1 for rent in 3-bedroom apartment in Barcelona",
    rent: "450 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/635921?move-in=2022-05-31",
    permonth: "/month",
    id: 34,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 6 May",
    title: "Rooms for rent in 3-bedroom apartment in L'Hospitalet De Llo",
    rent: "450 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/611892?move-in=2022-05-31",
    permonth: "/month",
    id: 35,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 31 May",
    title: "Welcoming room in shared apartment in Poble Sec, Barcelona",
    rent: "459 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/128488?move-in=2022-05-31",
    permonth: "/month",
    id: 36,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 13 April",
    title: "Room for rent in 3-bedroom flat in Barcelona",
    rent: "465 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/214797?move-in=2022-05-31",
    permonth: "/month",
    id: 37,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 21 April",
    title: "Room for rent in 2-bedroom apartment in Barcelona",
    rent: "470 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/642257?move-in=2022-05-31",
    permonth: "/month",
    id: 38,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 18 May",
    title: "Room for rent in 5-bedroom apartment in Sarrià-Sant Gervasi",
    rent: "470 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/309517?move-in=2022-05-31",
    permonth: "/month",
    id: 39,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 30 May",
    title: "Room for rent in 3-bedroom apartment in Poble-sec",
    rent: "470 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/294347?move-in=2022-05-31",
    permonth: "/month",
    id: 40,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 31 May",
    title: "Spacious room for rent in Navas, Barcelona",
    rent: "475 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/396064?move-in=2022-05-31",
    permonth: "/month",
    id: 41,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 31 May",
    title: "Room in 5-bedroom apartment in Horta-Guinardó, Barcelona",
    rent: "475 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/315445?move-in=2022-05-31",
    permonth: "/month",
    id: 42,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 13 May",
    title: "Room for rent in 3-bedroom apartment in Gracia, Barcelona",
    rent: "480 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/576426?move-in=2022-05-31",
    permonth: "/month",
    id: 43,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 18 May",
    title: "Room with balcony in 7-bedroom apartment in Barcelona",
    rent: "480 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/153885?move-in=2022-05-31",
    permonth: "/month",
    id: 44,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 30 March",
    title: "Room with kitchen in 2-bedroom apartment in Nou Barris",
    rent: "490 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/230114?move-in=2022-05-31",
    permonth: "/month",
    id: 45,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 19 May",
    title: "Room in  in 3-bedroom apartment in Sants, Barcelona",
    rent: "490 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/242074?move-in=2022-05-31",
    permonth: "/month",
    id: 46,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 30 May",
    title: "Room for rent in 4-bedroom apartment in Barcelona",
    rent: "490 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/652307?move-in=2022-05-31",
    permonth: "/month",
    id: 47,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 31 May",
    title: "Room for rent in 3-bedroom apartment in Barcelona",
    rent: "499 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/478728?move-in=2022-05-31",
    permonth: "/month",
    id: 48,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 13 May",
    title: "Cozy room for rent in Les Corts, Barcelona",
    rent: "500 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/366692?move-in=2022-05-31",
    permonth: "/month",
    id: 49,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 14 May",
    title: "Room for rent, 3-bedroom apartment,  Sarrià-Sant Gervasi",
    rent: "500 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/368356?move-in=2022-05-31",
    permonth: "/month",
    id: 50,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 16 May",
    title: "Room for rent in 2-bedroom apartment in Sant Gervasi",
    rent: "500 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/360595?move-in=2022-05-31",
    permonth: "/month",
    id: 51,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 21 May",
    title: "Bedroom in shared apartment in Sant Martí, Barcelona",
    rent: "500 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/100637?move-in=2022-05-31",
    permonth: "/month",
    id: 52,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 22 May",
    title: "Furnished room in 3-bedroom apartment in Eixample, Barcelona",
    rent: "500 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/89150?move-in=2022-05-31",
    permonth: "/month",
    id: 53,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 30 May",
    title: "Big room, 2-bed apartment, Sarrià-Sant Gervasi, Barcelona",
    rent: "500 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/147262?move-in=2022-05-31",
    permonth: "/month",
    id: 54,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 31 May",
    title: "Room in 5-bedroom apartment in Horta-Guinardó, Barcelona",
    rent: "515 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/315442?move-in=2022-05-31",
    permonth: "/month",
    id: 55,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 24 May",
    title: "Comfortable room in shared apartment in El Born, Barcelona",
    rent: "520 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/101228?move-in=2022-05-31",
    permonth: "/month",
    id: 56,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 31 May",
    title: "Room for rent in 6-bedroom apartment in Barcelona",
    rent: "520 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/639146?move-in=2022-05-31",
    permonth: "/month",
    id: 57,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 May",
    title: "Tidy room in 3-bedroom apartment in Barri Gòtic Barcelona",
    rent: "525 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/208136?move-in=2022-05-31",
    permonth: "/month",
    id: 58,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 5 May",
    title: "Spacious room, 3-bedroom apartment in Barri Gòtic Barcelona",
    rent: "525 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/167074?move-in=2022-05-31",
    permonth: "/month",
    id: 59,
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 6 April",
    title: "Room for rent in arty 2-bedroom apartment, Sants, Barcelona",
    rent: "530 €",
    link: "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/barcelona/for-rent:rooms/393699?move-in=2022-05-31",
    permonth: "/month",
    id: 60,
  },
];
